import React, { Component } from 'react';
import { Menu, Segment } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'

export default class Docs extends Component {
// const Problem = props => {

state = { activeItem: 'problem' }

handleItemClick = (e, { name }) => this.setState({ activeItem: name })



render(){
  const { activeItem } = this.state


  return (


      <div style={{'text-align':'left'}}>

        <Menu attached='top' tabular>
          <Menu.Item name='problem' active={activeItem === 'problem'} onClick={this.handleItemClick}>Решение проблем</Menu.Item>

        </Menu>
       <Segment attached='bottom'>

         <table>
         <tr><td colspan="2"><h5>Руководящие</h5></td></tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1241509344.pdf" target="_blank">Положение о компьютерной сети Тульского государственного университета</a><br/>
         	(217.4 kB)
         	</td>
         	</tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1257758218.pdf" target="_blank">Приказ №573 от 14.04.2008 "Об обеспечении надежного функционирования компьютерной сети университета"</a><br/>
         	(145.6 kB)
         	</td>
         	</tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1286954935.pdf" target="_blank">План работы ОЦНИТ ТулГУ на 2010 г.</a><br/>
         	(219.1 kB)
         	</td>
         	</tr>

         </table>

         <table>
         <tr><td colspan="2"><h5>Служебные</h5></td></tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1424076494.pdf" target="_blank">Служебная записка о разрешении доступа к Интернету</a><br/>
         	(312.4 kB)
         	</td>
         	</tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1448363317.pdf" target="_blank">Служебная записка о назначении ответственного за сегмент компьютерной сети</a><br/>
         	(422.9 kB)
         	</td>
         	</tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1459856323.pdf" target="_blank">Заявка на подключение к компьютерной сети ТулГУ</a><br/>
         	(364.2 kB)
         	</td>
         	</tr>

         	<tr>
         	<td><img alt='pdf Icon' src="http://ocnit.tula.ru/imge/docicons/pdf.png"/></td>
         	<td><a href="http://ocnit.tula.ru/userdocs/d1471333995.pdf" target="_blank">Служебная записка о подключении к компьютерной сети ТулГУ (для подразделений в первом учебном корпусе)</a><br/>
         	(378.4 kB)
         	</td>
         	</tr>

         </table>
        </Segment>

      </div>
  )
}
}

// export default Problem
